import styled, { css } from 'styled-components';

import { ButtonWithRef } from 'components/button';

export const Text = styled.p<{ isRed?: boolean; isBold?: boolean }>`
  ${({ theme, isRed, isBold }) => css`
    color: ${isRed ? theme.config.text.red : theme.config.text.primary};

    ${isBold &&
    css`
      font-weight: 600;
    `}
  `}
`;

export const AddRowButton = styled(ButtonWithRef)`
  margin-top: 8px;
  width: fit-content;
`;
